export class FileUtilities {
  constructor() { }

  downloadCSV(filename, url) {
    let pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    document.body.appendChild(pom);
    setTimeout(function () {
      pom.click();
      document.body.removeChild(pom);
    }, 66);
  }
}
